<template>
  <div>
    <div class="col-11 mx-auto text-left pb-3 ">
      <router-link
        :to="{ name: 'Home' }"
        class="text-left text-secondary font-weight-bold ml-2 mr-auto d-flex align-content-center"
      >
        <ArrowLeftLogo />
        <span>Torna alla home</span>
      </router-link>
    </div>
    <h1 class="pb-2">Il tuoi messaggi</h1>
    <div
      class="mx-auto"
      v-if="!noMsg"
      :class="isMobile ? 'd-flex flex-wrap' : 'row'"
    >
      <div class="ml-auto mr-2" :class="isMobile ? 'col-12' : 'col-5'">
        <b-container
          fluid
          class="col-12 border-secondary mx-auto border__div px-0 pt-0 pb-4 mb-2"
        >
          <div class="d-flex flex-column">
            <div
              v-for="(contatto, ind) in contatti"
              :key="ind"
              class="col-12 text-left py-2 point mt-2"
              :class="
                contatto.hashid == selected.hashid && 'bg-grey text-right'
              "
              @click="selectThis(contatto)"
            >
              <div class="mt-2">
                <span class="text-secondary text-left font-weight-bold">{{
                  contatto.anagrafica.fullname
                }}</span>
                <!-- <span class="text-text-dark-grey text-right">{{contatto.anagrafica.fullname}}</span> -->
              </div>
            </div>
          </div>
        </b-container>
      </div>

      <div
        :class="isMobile ? 'col-12 mx-auto' : 'col-lg-5 col-md-6 mr-auto ml-2'"
      >
        <conversazione v-if="selected" :destinatario="selected" />
        <b-container
          fluid
          class="col-12 border-secondary mx-auto border__div px-0 pt-0 pb-4 mb-2 conversazione"
          v-else
        ></b-container>
      </div>
    </div>
    <div v-else>
      <p class="text-center">Nessun messaggio.</p>
    </div>
  </div>
</template>
<script>
import Conversazione from "@/components/Conversazione";

import ArrowLeftLogo from "@/../public/svg/arrow_left.svg";
export default {
  name: "Messaggi",
  components: { Conversazione, ArrowLeftLogo },
  data() {
    return {
      lista: [],
      selected: null,
      contatti: [],
      loading: true,
      noMsg: false,
    };
  },
  computed: {
    isMobile: function() {
      return this.$root.device < 575;
    },
  },
  methods: {
    fetchLatest(el) {
      this.loading = true;
      var url =
        process.env.VUE_APP_VERSION +
        "messaggio/all?destinatario=" +
        el.hashid +
        "&latest=latest";
      this.$axios
        .get(url)
        .then((res) => {
          // console.log("latest", res.data.data);
        })
        .catch((err) => {
          // console.log(err);
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    selectThis(contatto) {
      // console.log("click", contatto);

      this.selected = false;
      this.selected = contatto;
    },
    fetchData() {
      this.loading = true;
      var url = process.env.VUE_APP_VERSION + "users/contatti";
      this.$axios
        .get(url)
        .then((res) => {
          // console.log(res.data.data);
          this.contatti = res.data.data;
          this.selected = this.contatti[this.contatti.length - 1];
          this.loading = false;
          if (res.data.data && res.data.data.length > 0) {
            res.data.data.map((el) => {
              // this.fetchLatest(el);
            });
          } else {
            this.noMsg = true;
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
